<template>
  <section>
    <div class="row my-4">
      <div class="col-md-8 offset-md-2 text-center">
        <img src="https://beneat.s3-ap-southeast-1.amazonaws.com/promotions/img_xl_line_coins.png"
              alt=""
              class="img-fluid rounded">
        <div class="mt-4">
          <div>รับส่วนลด 50 บาท!! เพียงเพิ่มเราเป็นเพื่อนทาง Line</div>
          <div>Get discount 50 THB OFF by connecting us with your line messenger.</div>
        </div>
      </div>
    </div>
    <div class="row my-4 text-center" v-if="validate === 1">
      <div class="col-md-12">
        <h3>กดปุ่ม Line เพิ่อเชื่อมต่อ Account ของคุณ</h3>
        <template v-if="isLineUser">
          <img class="img-disabled" height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
          <h4 class="mt-2">คุณลูกค้าได้เคยทำการเชื่อมต่อกับ Line เรียบร้อยแล้วค่ะ</h4>
        </template>
        <template v-else>
          <a :href="apiUrl" target="_blank">
            <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
          </a>
        </template>
      </div>
    </div>
    <div class="row my-4 text-center" v-else-if="validate === 0">
      <div class="col-md-12">
        ระบบกำลังทำการตรวจสอบ กรุณารอสักครู่...
      </div>
    </div>
    <div class="row my-4 text-center" v-else>
      <div class="col-md-12 text-danger">
        เกิดข้อผิดพลาด กรุณาแจ้งแอดมินเพื่อทำการตรวจสอบค่ะ
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        queryData: {
          user_id: null,
          validation: null
        },
        validate: 0,
        isLineUser: false,
        apiUrl: ''
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        state: 'user/getState'
      })
    },
    methods: {
      validateUser () {
        this.$http.get('line/validate', { params: this.queryData })
          .then(response => {
            return response.json()
          })
          .then(response => {
            console.log(response)
            if (!response.error) {
              this.validate = 1
              this.isLineUser = Number(response.line_user) === 1
            } else {
              this.validate = 2
            }
          })
      }
    },
    created () {
      this.$store.commit('user/SET_NO_DATA')
      if (this.$route.query.user_id) {
        this.queryData.user_id = this.$route.query.user_id
      } else if (this.user && this.user.id) {
        this.queryData.user_id = this.user.id
      }
      if (this.$route.query.validation) {
        this.queryData.validation = this.$route.query.validation
      }
      const code = Math.floor(Math.random() * 10000)
      const callback = encodeURIComponent(`https://beneat.co/line/callback?user_id=${this.queryData.user_id}`)
      this.apiUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1653340017&redirect_uri=${callback}&code=${code}&state=${code}&scope=openid%20profile&bot_prompt=aggressive`
      this.validateUser()
    }
  }
</script>

<style scoped>
  .img-disabled {
      opacity: 0.5;
      filter: alpha(opacity=50);
  }
</style>



// WEBPACK FOOTER //
// src/components/information/LineLogin.vue